import { Component, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ReactiveFormsModule } from '@angular/forms'
import { NavigationEnd, Router, RouterOutlet } from '@angular/router'
import { filter, take } from 'rxjs'
import { MasterCommonServices } from '../quotation/master.common.service'

@Component({
  selector: 'app-masters',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterOutlet],
  templateUrl: './masters.component.html',
  styleUrl: './masters.component.css',
})
export class MastersComponent implements OnInit {
  selectedItem: any
  flag: boolean = false
  permissions: string[] = []
  itemList: any[] = [
    { label: 'Delivered To', link: 'deliveredTo' },
    { label: 'Delivery Time', link: 'deliveryTime' },
    { label: 'Payment Type', link: 'paymentType' },
    { label: 'Validity', link: 'validity' },
    { label: 'Mtc Type', link: 'mtcType' },
    { label: 'Transport Mode', link: 'transportMode' },
    { label: 'Quotation Close Reason', link: 'quotationCloseReason' },
    { label: 'Hsn', link: 'hsn' },
    { label: 'Currency', link: 'currency' },
  ];

  constructor(
    private router: Router,
    private masterCommonService: MasterCommonServices,
  ) {
    this.flag = false
  }

  ngOnInit(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        if (event.url == '/masters') {
          this.selectItem(this.itemList[0])
        } else if (event.url.startsWith('/masters') && this.flag == false) {
          const url: string = event.url
          const routes: string[] = url.split('/')
          if (routes.length >= 3) {
            const ind: number = this.itemList.findIndex(
              (item) => item.link === routes[2],
            )
            if (ind !== -1) {
              this.selectItem(this.itemList[ind])
            } else {
              this.selectItem(this.itemList[0])
            }
          }
        }
      })

    if (this.masterCommonService.isDataLoaded == false) {
      this.masterCommonService.getAllMasters()
    }
  }

  selectItem(item: any) {
    if (item.disabled) return; // Prevent navigation if the item is disabled
    this.flag = true;
    this.selectedItem = item;
    this.router.navigate(['masters', item.link]);
  }

  isDisabled(item: any): boolean {
    return item.disabled;
  }

  isSelected(item: any): boolean {
    return this.selectedItem === item
  }

  transformString(str: string): string {
    return str.replace(/\s+/g, '')
  }
}
